import { useRef } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { apiError } from "@/lib/api";

/** Super admin delete of an activity entry / notification via the audited All-records endpoints. */
export const superDelete = async (what, call) => {
  if (!window.confirm(`Delete this entry?\n\n${what}\n\nIt's removed for everyone and logged in the audit log. Approval codes and the request itself are not affected.`)) return false;
  try { await call(); toast.success("Entry deleted"); return true; } catch (e) { toast.error(apiError(e)); return false; }
};
export const deleteFeedEntry = (e) => superDelete(`${e.label} · ${e.title}`, () => api.delete(`/super/records/${e.ref.kind}/${e.ref.id}/entries/${e.ref.i}`, { params: { at: e.ref.at } }));
export const clearHistory = (kind, id, title) => superDelete(`Whole history of “${title}”`, () => api.delete(`/super/records/${kind}/${id}/entries`));
export const deleteNotification = (n) => superDelete(n.title, () => api.post("/super/records/notifications/delete", { ids: [n.id] }));

/** Long-press (touch) handlers that fire `fn` after ~550 ms. */
export const useLongPress = (fn) => {
  const t = useRef(null);
  const clear = () => clearTimeout(t.current);
  return fn ? { onTouchStart: () => { t.current = setTimeout(fn, 550); }, onTouchEnd: clear, onTouchMove: clear, onContextMenu: (e) => { e.preventDefault(); fn(); } } : {};
};

export const TrashButton = ({ onClick, testid }) => (
  <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); }} aria-label="Delete entry"
    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-slate-400 hover:bg-red-50 hover:text-red-600" data-testid={testid}>
    <Trash2 className="h-4 w-4" />
  </button>
);
